/* global axios */
import ApiClient from './ApiClient';

class TalkviaCreditProductsAPI extends ApiClient {
  constructor() {
    super('talkvia_credit_products', { accountScoped: true });
  }

  create(data) {
    return axios.post(this.url, { talkvia_credit_product: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { talkvia_credit_product: data });
  }
}

export default new TalkviaCreditProductsAPI();
